import { call, takeLatest } from "redux-saga/effects";
import { addEventApi, addGuestBySponsorApi, ssoTokenApi } from "../../services/api/sso";
import { REQUEST_API_ADD_EVENT, REQUEST_API_ADD_GUEST_SPONSOR, REQUEST_API_SSO_TOKEN } from "../actions/actions";

function* ssoToken({ data: { sso_token } }) {
  try {
    const response = yield call(ssoTokenApi, sso_token);
    if (response.data) {
      sessionStorage.setItem("access_token", response.data["access_token"]);
      sessionStorage.setItem("x-refresh-token", response.data["x-refresh-token"]);
      let id_redirect = sessionStorage.getItem("redirect");
      if (!id_redirect) {
        window.location.replace(`${process.env.REACT_APP_BASE_API}home-sso`);
      } else {
        window.location.replace(`${process.env.REACT_APP_BASE_API}confirm-account-sponsor/${id_redirect}`);
      }
    } else {
      window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    }
  } catch (e) {
    window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    console.log(e);
  }
}
function* addEvent({ data: { body, callback } }) {
  try {
    // do api call
    const res = yield call(addEventApi, body);
    const { status } = res;
    callback(status || res.response.status);
  } catch (e) {}
}
function* addGuestBySponsor({ data: { body, callback } }) {
  try {
    // do api call
    const res = yield call(addGuestBySponsorApi, body);
    const { status } = res;
    callback(status || res.response.status);
  } catch (e) {}
}

export function* ssoTokenSaga() {
  yield takeLatest(REQUEST_API_SSO_TOKEN, ssoToken);
}
export function* addEventSaga() {
  yield takeLatest(REQUEST_API_ADD_EVENT, addEvent);
}
export function* addGuestBySponsorSaga() {
  yield takeLatest(REQUEST_API_ADD_GUEST_SPONSOR, addGuestBySponsor);
}
